import { useEffect, useState } from 'react';
import swipeArrow from '../../assets/images/pedometer/swipe-arrow.png';

/** 포인트 패널로 한 번이라도 스와이프하면 이후 유도 미노출 */
export const SWIPE_HINT_DONE_KEY = 'playground-pedometer-swipe-done';

const BOUNCES_PER_SET = 3;
const SETS = 3;
const PAUSE_MS = 1000;
const EXPAND_MS = 1000;
const HOLD_MS = 300;
const COLLAPSE_MS = 1000;

export function isSwipeHintDone() {
  try {
    return localStorage.getItem(SWIPE_HINT_DONE_KEY) === '1';
  } catch (error) {
    return false;
  }
}

export function markSwipeHintDone() {
  try {
    localStorage.setItem(SWIPE_HINT_DONE_KEY, '1');
  } catch (error) {
    // private mode 등
  }
}

/**
 * 정책: [뿅×3 → 1초 정지] × 3세트 후 사라짐.
 * 위치는 우측 고정, 화살표만 왼쪽으로 늘어났다 줄어든다.
 */
function PedometerSwipeHint({ active }) {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!active || isSwipeHintDone()) {
      setVisible(false);
      setExpanded(false);
      return undefined;
    }

    setVisible(true);
    let cancelled = false;
    const timers = [];

    const wait = (ms) =>
      new Promise((resolve) => {
        const id = window.setTimeout(resolve, ms);
        timers.push(id);
      });

    const bounce = async () => {
      setExpanded(true);
      await wait(EXPAND_MS + HOLD_MS);
      if (cancelled) return;
      setExpanded(false);
      await wait(COLLAPSE_MS);
    };

    const run = async () => {
      for (let set = 0; set < SETS; set += 1) {
        for (let bounceNo = 0; bounceNo < BOUNCES_PER_SET; bounceNo += 1) {
          if (cancelled) return;
          // eslint-disable-next-line no-await-in-loop
          await bounce();
        }
        if (cancelled) return;
        if (set < SETS - 1) {
          // eslint-disable-next-line no-await-in-loop
          await wait(PAUSE_MS);
        }
      }
      if (!cancelled) {
        setVisible(false);
        setExpanded(false);
      }
    };

    run();

    return () => {
      cancelled = true;
      timers.forEach((id) => window.clearTimeout(id));
    };
  }, [active]);

  if (!visible) {
    return null;
  }

  return (
    <div className="pdm-swipe" aria-hidden="true">
      <span className="pdm-swipe__label">당겨보세요~</span>
      <div className={`pdm-swipe__clip${expanded ? ' is-expanded' : ''}`}>
        <img src={swipeArrow} alt="" className="pdm-swipe__img" />
      </div>
    </div>
  );
}

export default PedometerSwipeHint;
